export const localesSelectors = {
  getAllLocales: (state) => state.localesReducer.locales,
  getSelectedLocale: (state) => state.localesReducer.selectedLocale,
};
